// src/modules/competitions/components/JudgeApplicationButton.tsx

import React from 'react';
import Button from '../../../shared/components/ui/Button';
import { JudgeApprovalStatus } from '../types/judge';

interface JudgeApplicationButtonProps {
  isParticipant: boolean;
  judgeStatus: JudgeApprovalStatus | null;
  onApply: () => void;
  onNavigateToPanel: () => void;
}

const JudgeApplicationButton: React.FC<JudgeApplicationButtonProps> = ({
  isParticipant,
  judgeStatus,
  onApply,
  onNavigateToPanel
}) => {
  // Si es participante, no mostrar nada
  if (isParticipant) {
    return (
      <div className="judge-participant-notice">
        <p>✅ Ya estás inscrito como participante en esta competencia</p>
        <p className="notice-subtitle">
          Los participantes no pueden postular como jueces
        </p>
      </div>
    );
  }

  // Si no hay estado, mostrar botón para postular
  if (!judgeStatus) {
    return (
      <Button
        variant="secondary"
        size="lg"
        onClick={onApply}
        leftIcon={<span>🧑‍⚖️</span>}
      >
        Postular como Juez
      </Button>
    );
  }

  // Si hay postulación pendiente
  if (judgeStatus === 'pending') {
    return (
      <div className="judge-status-badge judge-status-badge--pending">
        <span className="badge-icon">⏳</span>
        <div className="badge-content">
          <span className="badge-title">Postulación Pendiente</span>
          <span className="badge-subtitle">
            Estamos revisando tu solicitud
          </span>
        </div>
      </div>
    );
  }

  // Si fue aprobado
  if (judgeStatus === 'approved') {
    return (
      <Button
        variant="success"
        size="lg"
        onClick={onNavigateToPanel}
        leftIcon={<span>✅</span>}
      >
        Ir a Panel de Juez
      </Button>
    );
  }

  // Si fue rechazado
  if (judgeStatus === 'rejected') {
    return (
      <div className="judge-status-badge judge-status-badge--rejected">
        <span className="badge-icon">❌</span>
        <div className="badge-content">
          <span className="badge-title">Postulación Rechazada</span>
          <span className="badge-subtitle">
            Tu solicitud no fue aprobada
          </span>
        </div>
      </div>
    );
  }

  return null;
};

export default JudgeApplicationButton;